export default "__VITE_ASSET__DsGqO8BQ__"